import { ViewModel,View, ObservableArray } from "binder"
import { SearchableSelectorBaseViewModel } from "src/common/reusableComponents/searchableSelectorBase/searchableSelectorBase-viewModel";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { ServerSideDataLoader, PaginationInfo, FileSelectorViewModel } from "uicomponents";
import { PncSelectorSearchableViewModel } from "../pncManipulation/pncManipulation-viewModel";
import  { PartNumberManipulationView } from "./partNumberManipulation-view"
import { downloadFile } from "src/uicomponents/components/utilities";

export class PartNumberManipulationViewModel extends  WindowViewModel{
    public getTitle(): string {
        return 'مدیریت کد کالا ها ‌';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.partNumbers = ObservableArray.create<PartNumber>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
        this.fileSelector = new FileSelectorViewModel(this);
    }
    GetDefaultView(): View <ViewModel> {
        return new PartNumberManipulationView();
    }
    public getTypeId(): string {
        return "VM-E4264851-4FE8-4320-918D-7B8F6EDD1352"
    }public set partNumbers(v: ObservableArray<PartNumber>) { this._partNumbers = v; } public get partNumbers(): ObservableArray<PartNumber> { return this._partNumbers;} private _partNumbers: ObservableArray<PartNumber>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set fromProductCode(v: string) { this._fromProductCode = v; } public get fromProductCode(): string { return this._fromProductCode;} private _fromProductCode: string;
    public set toProductCode(v: string) { this._toProductCode = v; } public get toProductCode(): string { return this._toProductCode;} private _toProductCode: string;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllPartNumber',{
                FilteringInformation:filteringInformation
            });
            this.partNumbers.update(...result.PartNumber.map(q=>{
                let r = new PartNumber(this);
                r.id = q.Id;
                r.pncId = q.PncId;
                r.pncName = q.PncName;
                r.pncCode = q.PncCode;
                r.pncTitle = `${r.pncCode} (${r.pncName})`;
                r.code = q.Code;
                r.name = q.Name;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    
    async requestPartNumberCreation(){
        let editor = new partNumberEditor(this,new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async partNumberUpdater(partNumber:PartNumber){
        let editor = new partNumberEditor(this,new UpdateServerUpdater());
        partNumber.cloneTo(editor);
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async export(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/ExportPartNumber',{
                FromCode: this.fromProductCode,
                ToCode: this.toProductCode,
            });
            await this.messageBoxConfirmSuccess('فایل خروجی با موفقیت بارگذاری شد.','عملیات موفق');
            downloadFile(result.ExcelData, `export_part_numbers.xlsx`);
            return result;
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async import(){
        try {
            let errors :string[]= [];
            if(!this.fileSelector?.isFileChoosed()){
                errors.push('فایلی انتخاب نشده است.');
            }
            let validationResult = errors.join("\n");
            if(validationResult != ""){
                await this.messageBoxConfirmWarning(validationResult,"خطا");
                return ;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/ImportPartNumber',{
                ExcelFile : this.fileSelector.filecontent
            });
            if (result.IsSuccessful == false) {
                throw 'error';
            }
            await this.messageBoxConfirmSuccess('کد کالاها با موفقیت بروزسانی شد.','عملیات موفق');
            this.refresh();
            return result;
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}

export class PartNumber extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:PartNumberManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set pncId(v: string) { this._pncId = v; } public get pncId(): string { return this._pncId;} private _pncId: string;
    public set pncName(v: string) { this._pncName = v; } public get pncName(): string { return this._pncName;} private _pncName: string;
    public set pncCode(v: string) { this._pncCode = v; } public get pncCode(): string { return this._pncCode;} private _pncCode: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set pncTitle(v: string) { this._pncTitle = v; } public get pncTitle(): string { return this._pncTitle;} private _pncTitle: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    
    private _typedParent:PartNumberManipulationViewModel;

    cloneTo(partNumber:PartNumber){
        partNumber.id = this.id;
        partNumber.setPnc(this.getPncId(),this.pncTitle);
        partNumber.code = this.code;
        partNumber.name = this.name;
    }

    async edit(){
        this._typedParent.partNumberUpdater(this);
    }    
    
    setPnc(id: string, name: string) {
        this.pncId = id;
        this.pncTitle = name;
    }
    
    getPncId() {
        return this.pncId;
    }    

}

interface IServerUpdater{
    execute(partNumber:PartNumber):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'کد کالا با موفقیت ثبت شد.';
    }
    async execute(partNumber: PartNumber): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/CreatePartNumber',{
            PncId:partNumber.getPncId(),
            Code:partNumber.code,
            Name:partNumber.name
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}
class UpdateServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'کد کالا با موفقیت به روز رسانی شد.';

    }
    async execute(partNumber: PartNumber): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/UpdatePartNumber',{
            Id:partNumber.id,
            PncId:partNumber.getPncId(),
            Code:partNumber.code,
            Name:partNumber.name
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}

export class partNumberEditor extends PartNumber implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:PartNumberManipulationViewModel,serverUpdater:IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        this.pncSelector = new PncSelectorSearchableViewModel(this);
        this.pncSelector.onSelectionChanged = q=>{
            this.pncTitle = q.title;
            this.pncId = q.id;
        }
    }
    closePopup(resultCode: string = null) {
    }
    
    private _serverUpdater:IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set pncSelector(v: PncSelectorSearchableViewModel) { this._pncSelector = v; } public get pncSelector(): PncSelectorSearchableViewModel { return this._pncSelector;} private _pncSelector: PncSelectorSearchableViewModel;
    
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.getPncId())){
            result.push('PNC مشخص نشده است.')
        } 
        if(stringIsNullOrEmpty(this.code)){
            result.push('کد کد کالا مشخص نشده است.')
        }
        return result;
    }

    setPnc(id: string, name: string) {
        this.pncSelector.selectById(id);
        this.pncId = id;
        this.pncTitle = name;
    }

    getPncId() {
        return this.pncId;
    }
    
    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت کد کالا');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }
}

export class PartNumberSelectorViewModel extends SelectorBaseViewModel<partNumberForSelector>{
    protected async loadData(): Promise<partNumberForSelector[]> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllPartNumber',{});
        return result.PartNumber.map(q=>{
            let result = new partNumberForSelector(this);
            result.id = q.Id;
            result.title = `${q.Code} - (${q.PncName})`;
            return result;
        });
    }

}

class partNumberForSelector extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);   
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set pncName(v: string) { this._pncName = v; } public get pncName(): string { return this._pncName;} private _pncName: string;
    
}

export class PartNumberSearchViewModel extends SearchableSelectorBaseViewModel<partNumberForSelector>{

    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    protected async loadData(searchedText: string): Promise<partNumberForSelector[]> {
        let result = await ServerConnection.callServer('Complex/WarehouseServices/SearchPartNumbers',{
            SearchText:searchedText,
            ResultCount:20,
        });
        return result.PartNumbers.map(x=>this.convertSingle(x));
    }
    protected async loadById(id: string): Promise<partNumberForSelector> {
        let result = await ServerConnection.callServer('Complex/WarehouseServices/SearchPartNumbersById',{
            Id:id
        });    
        return this.convertSingle(result.Product);
    }
    
    private convertSingle(dto:any):partNumberForSelector{
        var p = new partNumberForSelector(this);
        p.id = dto.Id;
        p.code = dto.PartNumberCode;
        p.pncName = dto.PncName;
        p.title = `${dto.PartNumberCode} - (${dto.PncName})`;
        return p;
    }
}
